import { Injectable } from '@angular/core';
import {DatePipe} from '@angular/common';

export const longMinDate = {year: 1980, month:1, day:1};
export const longMaxDate = {year: (new Date()).getFullYear() + 10, month: 12, day: 31};

@Injectable({
  providedIn: 'root'
})
export class TimeService {

  constructor() { }

  /**
   * Get a lsit with years
   *
   * @param min
   * @param max
   * @constructor
   */
  getYearList(min: any = null, max: any = null, order = 'asc') {
    const date = new Date();
    let years = [];
    if (min == null) min = 1990;
    if (max == null) max = date.getFullYear() + 10;
    for (let i = min; i <= max; i++)  {
      years.push({value: i, label: i});
    }
    if (order == 'desc') years = years.reverse();
    return years;
  }

  getMonthList() {
    return [
      {
        value: 1,
        label: 'January'
      },
      {
        value: 2,
        label: 'February'
      },

      {
        value: 3,
        label: 'March'
      },
      {
        value: 4,
        label: 'April'
      },
      {
        value: 5,
        label: 'May'
      },
      {
        value: 6,
        label: 'June'
      },
      {
        value: 7,
        label: 'July'
      },
      {
        value: 8,
        label: 'August'
      },
      {
        value: 9,
        label: 'September'
      },
      {
        value: 10,
        label: 'October'
      },
      {
        value: 11,
        label: 'November'
      },
      {
        value: 12,
        label: 'December'
      },
      ];
  }

  /**
   * Parse a date string to date object
   *
   * @param value
   */
  parseDatestring(value: any) {
    const date = new Date();
    if (!value) return date;
    if (value.length !== 10) return date;

    const year = value.substr(0, 4);
    const month = value.substr(5, 2);
    const day = value.substr(8, 2);

    date.setFullYear(parseInt(year, 10));
    date.setMonth(parseInt(month, 10) - 1);
    date.setDate(parseInt(day, 10));
    return date;
  }

  parseDateToISOString(date:Date) {
    return date.toISOString()
  }
}
